//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.wintermar.inspection.graphql.type.StartInspectionCommandInput
import kotlin.IllegalStateException

public object StartInspectionCommandInput_InputAdapter : Adapter<StartInspectionCommandInput> {
  override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): StartInspectionCommandInput = throw IllegalStateException("Input type used in output position")

  override fun toJson(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    `value`: StartInspectionCommandInput,
  ) {
    writer.name("id")
    AnyAdapter.toJson(writer, customScalarAdapters, value.id)
    writer.name("templateId")
    AnyAdapter.toJson(writer, customScalarAdapters, value.templateId)
    writer.name("conductedAt")
    AnyAdapter.toJson(writer, customScalarAdapters, value.conductedAt)
  }
}
